module.exports = __webpack_public_path__ + "static/media/bp_banner_large.aa32e0de.png";